import { render, staticRenderFns } from "./ShippingOrderManagement.vue?vue&type=template&id=36cce052"
import script from "./ShippingOrderManagement.vue?vue&type=script&lang=ts"
export * from "./ShippingOrderManagement.vue?vue&type=script&lang=ts"
import style0 from "./ShippingOrderManagement.vue?vue&type=style&index=0&id=36cce052&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports